import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';

const NotFoundPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-16 text-center">
      <div className="max-w-lg mx-auto">
        <h1 className="text-6xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#7F56D9] to-[#F670C7]">
          404
        </h1>
        <h2 className="text-2xl font-bold mt-4 mb-2">Page Not Found</h2>
        <p className="text-[#A3A3A3] mb-8">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <div className="flex justify-center gap-4">
          <Link to="/">
            <Button variant="primary" size="lg">
              Go Home
            </Button>
          </Link>
          <Button
            variant="outline"
            size="lg"
            onClick={() => window.history.back()}
          >
            Go Back
          </Button>
        </div>

        {/* Decorative elements */}
        <div className="mt-16 relative">
          <div className="w-20 h-20 rounded-xl bg-gradient-to-br from-[#7F56D9] to-[#F670C7] opacity-60 transform rotate-12 animate-float mx-auto shadow-lg shadow-[#7F56D9]/20"></div>
          <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-transparent via-[#3A3643] to-transparent"></div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
